import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { getCurtainRailHexColour } from '../../../helpers/getHexColorCode';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorColour, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
    pullRodColour: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (pullRodColour, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
        pullRodColour,
    },
  });

export const PullRodColour = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);
  const pullRodColourOptions = baseProduct
    ? baseProduct.metafields.pullrod_colour || []
    : [];
  const { pullRodColour } = state.context.custom;

  if (!Array.isArray(pullRodColourOptions) || pullRodColourOptions.length === 0) {
    if (isCurrentState('pullRodColour', state)) {
      throwError(state);
    }
  }

  return (
    <SectionContent>
      <Heading>Pull Rod Colour</Heading>
      <Selector isSlider={true} isColorPicker={true}>
        {pullRodColourOptions.map(option => {
          return (
            <SelectorColour
              isSelected={option === pullRodColour}
              onClick={onClick(option, send)}
              key={option}
              colourName={option}
              colourCode={getCurtainRailHexColour(option)}
              colourSwatch={''}
            />
          );
        })}
      </Selector>
      <Caption>{pullRodColour}</Caption>
    </SectionContent>
  );
};
